"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStrategyMatrixData = void 0;
const react_redux_1 = require("react-redux");
const reselect_1 = require("reselect");
const reducers_1 = require("./reducers");
const selectors_1 = require("../../store/catalogs/selectors");
const selectStrategyMatrixData = (0, reselect_1.createSelector)(selectors_1.selectActiveCatalog, (activeCatalog) => (activeCatalog === null || activeCatalog === void 0 ? void 0 : activeCatalog.strategyMatrix) || reducers_1.defaultStrategyMatrixState);
const useStrategyMatrixData = () => (0, react_redux_1.useSelector)(selectStrategyMatrixData);
exports.useStrategyMatrixData = useStrategyMatrixData;
